/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUpcomingArtistConcertsQueryVariables = Types.Exact<{
  artistId: Types.Scalars['String'];
  countryIds?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
}>;


export type GetUpcomingArtistConcertsQuery = { __typename: 'Query', getUpcomingArtistConcerts: { __typename: 'UpcomingArtistConcertsResponse', totalConcertCount: number, concerts: Array<{ __typename: 'ArtistConcert', attendees: number | null, cityName: string | null, countryId: string, countryName: string, date: string, dateStatus: string | null, stateName: string | null, tourName: string | null, venue: string | null }> } };


export const GetUpcomingArtistConcertsDocument = gql`
    query getUpcomingArtistConcerts($artistId: String!, $countryIds: [String] = null) {
  getUpcomingArtistConcerts(
    artistId: $artistId
    countryIds: $countryIds
    limit: 100
  ) {
    totalConcertCount
    concerts {
      attendees
      cityName
      countryId
      countryName
      date
      dateStatus
      stateName
      tourName
      venue
    }
  }
}
    `;

/**
 * __useGetUpcomingArtistConcertsQuery__
 *
 * To run a query within a React component, call `useGetUpcomingArtistConcertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingArtistConcertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingArtistConcertsQuery({
 *   variables: {
 *      artistId: // value for 'artistId'
 *      countryIds: // value for 'countryIds'
 *   },
 * });
 */
export function useGetUpcomingArtistConcertsQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingArtistConcertsQuery, GetUpcomingArtistConcertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingArtistConcertsQuery, GetUpcomingArtistConcertsQueryVariables>(GetUpcomingArtistConcertsDocument, options);
      }
export function useGetUpcomingArtistConcertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingArtistConcertsQuery, GetUpcomingArtistConcertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingArtistConcertsQuery, GetUpcomingArtistConcertsQueryVariables>(GetUpcomingArtistConcertsDocument, options);
        }
export type GetUpcomingArtistConcertsQueryHookResult = ReturnType<typeof useGetUpcomingArtistConcertsQuery>;
export type GetUpcomingArtistConcertsLazyQueryHookResult = ReturnType<typeof useGetUpcomingArtistConcertsLazyQuery>;